import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import shortid from 'shortid'
import media from '../../styles/media'

//Components
import CustomModal from '../container/modal/modal'

const CustomLink = styled(Link)`
  display: block;
  text-decoration: none;
  font-size: 25px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  line-height: 1.08;
  &:hover {
    background: #38abe0;
  }
  margin-top: 10px;
  ${media.md`
    display: inline-block;
    line-height: 1.75;  
    padding: 0 15px;
    font-size: 40px;
  `};
`
const PpmTitle = styled.span`
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.87;
  letter-spacing: -0.3px;
  text-align: left;
  color: #ffffff;
  margin-top: 0px;
  ${media.md`
    padding: 15px;
  `};
`

const IconWrapper = styled.a`
  display: none;
  ${media.md`  
    display: flex;
    justify-content: flex-end;  
  `};
`

const ListItems = styled.ul`
  list-style-type: none;
  padding-left: 0px;
  ${media.md`  
    padding-left:40px;  
  `};
`

function Menu(props) {
  let menuItems
  const { isOpen, toggleMenu, items } = props
  if (items) {
    menuItems = items.map(item => (
      <li key={shortid.generate()}>
        <CustomLink to={item.node.link} onClick={() => toggleMenu(!isOpen)}>
          {item.node.title}
        </CustomLink>
      </li>
    ))
  }

  return (
    <CustomModal isOpen={isOpen}>
      <ListItems>
        <li>
          <PpmTitle>/PPM</PpmTitle>
        </li>
        <li>
          <CustomLink to="/" onClick={() => toggleMenu(!isOpen)}>
            Home
          </CustomLink>
        </li>
        {menuItems}
      </ListItems>
      <IconWrapper
        href="mailto:info@ppm.com.ec?Subject=Hello%20again"
        target="_top"
      >
        <i
          className="icon-mail"
          style={{
            fontSize: 25,
            cursor: 'pointer',
            color: 'white'
          }}
        />
      </IconWrapper>
    </CustomModal>
  )
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/menu/menu.js